import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { MainService } from './services/main.service';
import { UtilService } from './services/util.service';
import { Title } from '@angular/platform-browser';
import { APP_MODEL_DATA } from './model-data/app-model-data';
import { environment } from 'src/environments/environment';
import {  ModalDirective } from 'ngx-bootstrap/modal';
import { ISuccessError,ICommonModal,ICommonModalBody } from './interface-model/app-interface-model';
import { int } from 'aws-sdk/clients/datapipeline';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  checkIDSessionInterval: any;
  IdTokenExpiryTimeStamp: any;
  genericModalTitle:string='';
  isError:boolean=false;
  navigateTo:string='';
  langaugeKey:string="";
  isLangKey:boolean=false;
  clientId: string = environment.CLIENT_ID;
  refreshToken: string = "";
  retryCount: number = 0;
  appSpinner = APP_MODEL_DATA.APP_SPINNER;
  userAccountData:any;
  commonModalBody: ICommonModalBody[] = [];commonModalHrefLink:string="";isCommonModalButton:boolean=false;isSignout:boolean=false;

  constructor(private router: Router, public mainService: MainService,
    public translate: TranslateService, public utilService: UtilService, private titleService: Title) {
    this.utilService.checkLanguageConstraintForApp();
    this.refreshToken = this.utilService.getToken('refreshToken');
  }
  // Modal declartion
  @ViewChild('successErrorModal') public successErrorModal!:  ModalDirective;
  @ViewChild('commonModal') public commanModal!:  ModalDirective;

  ngOnInit(): void {
    // Setting Site-Page-Title dynamically using ngx-translate service
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.titleService.setTitle(event.translations.lang.siteTitle);
    });
    //Show up the Modal using ngx-bootstrap Modal Directive
    this.utilService.successErrorModal.subscribe((modalData) => {
      if (modalData.modalTitle) {
        this.showSuccessErrorModal(modalData);
      }
    });
    //Show up the common Modal using ngx-bootstrap Modal Directive
    this.utilService.commonModal.subscribe((modalData) => {
      if (modalData.commonModalBody) {
        this.showCommanModal(modalData);
      }
    });
    // Manage header navigation bar
    this.utilService.showNavigationBar.next(true);
    this.loadLoggedInUserDetailsFromExistingToken();
    let getAuthcodeData;
    let refreshToken = this.refreshToken;
    this.utilService.getAuthcode.subscribe((response) => {
      getAuthcodeData = response;
      if (getAuthcodeData) {
        this.mainService.exchangeTokenService("authorization_code", getAuthcodeData).subscribe({
          next: (exchangeTokenSuccess) => {
            // start temporary logic to show logged-in user email id in header
            let parsedIDTokenData = this.utilService.parseJwt(exchangeTokenSuccess.id_token);
            this.utilService.setLocalStorage("UserName", parsedIDTokenData.email);
            // end temporary logic to show logged-in user email id in header
            let _now = new Date();
            let expireInterval = exchangeTokenSuccess.expires_in;
            _now.setTime(_now.getTime() + 1 * (expireInterval * 1000));
            // based on IdTokenExpiryTimeStamp exchangeToken Api call will happen before 3 minutes of Expriy of Idtoken
            this.IdTokenExpiryTimeStamp = _now.getTime() + 1 * (expireInterval - APP_MODEL_DATA.EXPIRE_INTERVAL_BEFORE * 1000);
            document.cookie = `idToken=${exchangeTokenSuccess.id_token};  expires=${_now.toUTCString()}; path=/;Priority=High;secure;`;
            // add 1 day expiry time for refresh token
            let _nowRefresh = new Date();
            _nowRefresh.setTime(_now.getTime() + 1 * (APP_MODEL_DATA.GET_EXPIRY_TIME * 1000))
            document.cookie = `refreshToken=${exchangeTokenSuccess.refresh_token}; expires=${_nowRefresh.toUTCString()}; path=/;Priority=High;secure;`;
            this.utilService.setLocalStorage("isInitLoad","true");
            this.utilService.getSignedInMessage.next(true);
            
            if (this.checkIDSessionInterval) {
              clearInterval(this.checkIDSessionInterval)
            }
            this.startExchangeTokenInterval();
            this.getUserRoleFromUserInfo(parsedIDTokenData.user_id);
          },
          error: (error) => {
            // Handled by interceptor (network error popup + redirect to login)
          this.handleNetworkError(error);
          }
        });
      }
      else if (refreshToken) {
        this.checkForToken(true);
        if (this.checkIDSessionInterval) {
          clearInterval(this.checkIDSessionInterval);
        }
        this.startExchangeTokenInterval();
      }

    });
  }

 getUserRoleFromUserInfo(user_id:int) {
    this.mainService.getUserAccountInfo(user_id).subscribe({
      next: (getUserAccountInfoSuccess) => {
        var userAccountInfo = getUserAccountInfoSuccess;
        this.setLoggedInUserDetails(userAccountInfo);
      var previousRole = this.utilService.getLocalStorage('userRole');
      var launchDahsboard = false;
      if(previousRole!=undefined && previousRole!= userAccountInfo.role){
        // Refresh and launch the dashboard to ensure that only the features assigned to your current role are available.
        launchDahsboard = true;
      }

        this.utilService.setLocalStorage("userRole", userAccountInfo.role);
        if(userAccountInfo.role == APP_MODEL_DATA.INTERNAL){
          this.loadInternalUerSession();
        }
        else if(APP_MODEL_DATA.ALLOWED_ROLES.includes(userAccountInfo.role) && launchDahsboard) {
          this.router.navigate(["support-users/all"]);
        }
        else{
          this.loadUserSession();
        }
      },
      error: (error) => {
        this.handleNetworkError(error);
      }
    });
  }

  setLoggedInUserDetails(userAccountInfo: any): void {
    const { firstName = "", lastName = "", email } = userAccountInfo || {};
    this.utilService.setLocalStorage("loggedInUserFirstName", firstName);
    this.utilService.setLocalStorage("loggedInUserLastName", lastName);
    if (email) {
      this.utilService.setLocalStorage("UserName", email);
    }
    this.utilService.getSignedInMessage.next(true);
  }

  loadLoggedInUserDetailsFromExistingToken(): void {
    const hasExistingUserDetails =
      this.utilService.getLocalStorage("loggedInUserFirstName") || this.utilService.getLocalStorage("loggedInUserLastName");
    if (hasExistingUserDetails) {
      this.utilService.getSignedInMessage.next(true);
      return;
    }

    const tokenValue = this.utilService.getToken('idToken');
    if (!tokenValue) {
      return;
    }

    try {
      const parsedIDTokenData = this.utilService.parseJwt(tokenValue);
      if (parsedIDTokenData?.email) {
        this.utilService.setLocalStorage("UserName", parsedIDTokenData.email);
      }
      if (parsedIDTokenData?.user_id) {
        this.getUserRoleFromUserInfo(parsedIDTokenData.user_id);
        return;
      }
    } catch (error) {
      this.utilService.getSignedInMessage.next(true);
      return;
    }
    this.utilService.getSignedInMessage.next(true);
  }

  loadInternalUerSession(): void {
    this.router.navigate(["access-restricted"]);
  }

  loadUserSession(): void {
    // temporary logic to handle initial load
    let isInitLoad = this.utilService.getLocalStorage("isInitLoad");
    if(isInitLoad == "true") {
      this.router.navigate(["support-users/all"]);
      this.utilService.setLocalStorage("isInitLoad","false");
    }
  }  

  checkForToken(isOnload: boolean) {
    //call exchangeToken API only if client_id and refreshToken is present else clear storage and navigate to signin page.
    if (this.clientId && this.refreshToken) {
     this.mainService.exchangeTokenService("refresh_token").subscribe({
      next: (exchangeTokenSuccess) => {
      let now = new Date();
      let expireInterval = exchangeTokenSuccess.expires_in;
      now.setTime(now.getTime() + 1 * (expireInterval * 1000));
      // based on IdTokenExpiryTimeStamp exchangeToken Api call will happen before 3 minutes of Expriy of Idtoken
      this.IdTokenExpiryTimeStamp = now.getTime() + 1 * (expireInterval - APP_MODEL_DATA.EXPIRE_INTERVAL_BEFORE * 1000);
      document.cookie = `idToken=${exchangeTokenSuccess.id_token};  expires=${now.toUTCString()}; path=/;Priority=High;secure;`;
        this.utilService.getSignedInMessage.next(true);
      this.retryCount = 0; // reset retryCount if success
      // Below function will be executed only if page is reloaded or its loaded for first time.
      if (isOnload) {
        let parsedIDTokenData = this.utilService.parseJwt(exchangeTokenSuccess.id_token);
        this.getUserRoleFromUserInfo(parsedIDTokenData.user_id);
        }
      },
      error: (error) => {
        this.handleNetworkError(error);
      }
     });
    }
    else {
      this.utilService.clearStorage();
      this.router.navigate(["/sign-in"]);
    }
  }

  startExchangeTokenInterval(): void {
    this.checkIDSessionInterval = setInterval(() => {
      this.refreshToken = this.utilService.getToken('refreshToken');
      if (!this.refreshToken) {
        clearInterval(this.checkIDSessionInterval);
      }
      this.CheckIDSession();
    }, APP_MODEL_DATA.TOKEN_INTERVAL);
  }

  CheckIDSession(): void {
    // check if IdTokenExpiryTimeStamp is less than currentTimeStamp then call exchange token api to get new Id Token
    let currentTimeStamp = Date.now();
    if (this.IdTokenExpiryTimeStamp < currentTimeStamp) {
      this.checkForToken(false);
    }
  }

  private handleNetworkError(error: any): void {
    if (error.status === 0) {
      this.utilService.hideSpinner(this.appSpinner);
      this.utilService.clearStorage();
      let successErrorData: ISuccessError = {
        modalTitle: 'Error',
        isError: true,
        navigateTo: '/sign-in',
        langKey: 'lang.network_error',
        isLangKey: true
      };
      this.utilService.successErrorModal.next(successErrorData);
    }
  }

  /* Modal Functions Start */
  showSuccessErrorModal(successErrorData:ISuccessError): void {
    this.genericModalTitle = successErrorData.modalTitle ? successErrorData.modalTitle : '';
    this.isError = successErrorData.isError ? successErrorData.isError : false;
    this.langaugeKey = successErrorData.langKey ? successErrorData.langKey : '';
    this.isLangKey = successErrorData.isLangKey ? successErrorData.isLangKey : false;
    this.successErrorModal.show();
    if (successErrorData.navigateTo) {
      this.navigateTo = successErrorData.navigateTo;
    }
  }

  successErrorModalClose(navigateURL: any) {
    if (navigateURL) {
      this.router.navigate([navigateURL]);
      this.successErrorModal.hide();
    }
    else {
      this.mainService.goBack();
      this.successErrorModal.hide();
    }

  }

  showCommanModal(commonModaldata:ICommonModal): void {
    this.commonModalBody = commonModaldata.commonModalBody;
    this.isCommonModalButton = commonModaldata.isCommonModalButton;
    this.commanModal.show();
  }

  commanModalClose(isSignout:boolean) {
    if(isSignout)
    {
      this.utilService.signout();
      this.commanModal.hide();
    }
    else
    {
      this.commanModal.hide();
    }
  }
 /* Modal Functions End */
}



